<template>
    
	
    <section class="cards-sec position-relative">
        <div class="container">
            <div class="row main-row">
                <div class="col-lg-12">
                    <div class="main-wr">
						<div class="filters">
                            <button type="button" id="showfilters" class="btn d-inline-flex d-xl-none" @click="MobileFilter">
                                <feather-icon
									icon="FilterIcon"
									/>
                            </button>
							<div class="list-grid-btns">
								<button type="button" class="btn change-view" :class="(!isList)? ' active' : ''" @click="toggleList">
									<feather-icon
									icon="GridIcon"
									class="cursor-pointer"
									/>
								</button>
								<button type="button" class="btn change-view" :class="(isList)? ' active' : ''" @click="toggleList">
									<i class="fas fa-list-ul"></i>
								</button>
							</div>
							<div class="order-by">
								<!-- desktop version -->
								<div class="d-none d-lg-flex">
									<span class="lbl">{{ $t('gen.sort_by') }}</span>
									<ul class="nav nav-pills">
										<li class="nav-item">
											<a class="nav-link" :class="($store.state.filter.filter.sort_by == 'price')? ' active' : ''" @click=" $router.replace({ query: { ...$route.query, sort_by: 'price' } }) ">{{ $t('auction.current_price') }}</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" :class="($store.state.filter.filter.sort_by == 'auction_count')? ' active' : ''"  @click=" $router.replace({ query: { ...$route.query, sort_by: 'auction_count' } }) ">{{ $t('auction.bid_count') }}</a>
										</li>
										<li class="nav-item">
											<a class="nav-link"  :class="($store.state.filter.filter.sort_by == 'auction_end_date')? ' active' : ''" @click=" $router.replace({ query: { ...$route.query, sort_by: 'auction_end_date' } }) ">{{ $t('gen.close_time') }}</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" :class="($store.state.filter.filter.sort_by == 'year')? ' active' : ''" @click=" $router.replace({ query: { ...$route.query, sort_by: 'year' } }) "> {{ $t('gen.make_year') }}</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" :class="($store.state.filter.filter.sort_by == 'distance')? ' active' : ''" @click=" $router.replace({ query: { ...$route.query, sort_by: 'distance' } }) "> {{ $t('gen.km') }}</a>
										</li>
										<li class="nav-item">
											<a class="nav-link" v-if="inComingCount > 0" :class="($store.state.filter.show_cars == 'incoming')? ' active' : ''" @click="show_incoming()"> {{ $t('gen.incomming_auctions') }}</a>
										</li>
									</ul>
								</div>
								<!-- desktop version End -->
								<!-- mobile version -->
								<div class="d-block d-lg-none">
									<div class="dropdown dr-style1">
										<button class="btn  dropdown-toggle" type="button" id="dropdownMenuButton"
											data-toggle="dropdown" aria-expanded="false">
											{{ $t('gen.sort_by') }}
										</button>
										<div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
											<a class="dropdown-item"  @click=" $router.replace({ query: { ...$route.query, sort_by: 'price' } }) ">{{ $t('auction.current_price') }}</a>
											<a class="dropdown-item"  @click=" $router.replace({ query: { ...$route.query, sort_by: 'auction_count' } }) ">{{ $t('auction.bid_count') }}</a>
											<a class="dropdown-item"  @click=" $router.replace({ query: { ...$route.query, sort_by: 'auction_end_date' } }) ">{{ $t('gen.close_time') }}</a>
											<a class="dropdown-item"  @click=" $router.replace({ query: { ...$route.query, sort_by: 'year' } }) ">{{ $t('gen.make_year') }}</a>
											<a class="dropdown-item"  @click=" $router.replace({ query: { ...$route.query, sort_by: 'distance' } }) ">{{ $t('gen.km') }}</a>
											<a class="dropdown-item" v-if="inComingCount > 0"  @click=" show_incoming() "> {{ $t('gen.incomming_auctions') }}</a>
										</div>
									</div>
								</div>
							</div>
							<div class="sort">
								<button class="up btn " :class="($store.state.filter.filter.sort_type != 'desc')? ' active' : ''" @click="  $store.state.home.filter.sort_type = 'asc', $router.replace({ query: { ...$route.query, sort_type: 'asc' } }) ">
									<i class="fas fa-caret-up"></i>
								</button>
								<button class="down btn" :class="($store.state.filter.filter.sort_type == 'desc')? ' active' : ''" @click=" $store.state.home.filter.sort_type = 'desc',  $router.replace({ query: { ...$route.query, sort_type: 'desc' } }) ">
									<i class="fas fa-caret-down"></i>
								</button>
							</div>
							<div class="reset-wr">
								<router-link to="filter" class="reset-filters">
									<i class="fas fa-redo"></i>
									<span>{{ $t('gen.reset') }}</span>
                                </router-link>
							</div>
						</div>
                    </div>
                </div>
                <div id="sideFilters" class="col-xl-auto filter-col cstm-sm-scroll" :class="(filterMob ==1)? ' active' : ''">
                    <div class="position-relative">
                        <div class="d-flex d-xl-none top-btn">
                            <button @click="MobileFilter" id="hideFilters" class="close">
                                <i class="fas fa-times"></i>
                            </button>
                        </div>
                        <div class="side-filters ">
                            <form class="menu">
                                <div class="accordion" id="accordionExample">
                                    <div class="card" v-if="0">
                                        <div class="card-header" id="headingOne">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link btn-block" type="button"
                                                    data-toggle="collapse" data-target="#collapseOne"
                                                    aria-expanded="false" aria-controls="collapseOne">
                                                    <i></i>
                                                    {{ $t('gen.aucs') }}
                                                </button>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                                            data-parent="#accordionExample">
                                            <div class="card-body">
                                                <button class="btn reset-btn" type="button" @click="clearAuctions">
                                                    <feather-icon icon="XIcon" />
                                                    {{ $t('gen.card50') }}
                                                </button>
                                                <div class="scroll">
                                                    <div class="item" v-for="(auction, index) in auctions" :key="index">
                                                        <div
                                                            class="custom-control custom-control-success custom-checkbox">
                                                            <input type="checkbox" v-model="auctionsL" :value="auction.id" class="custom-control-input "
                                                                :id="'Check'+auction.id">
                                                            <label class="custom-control-label" :for="'Check'+auction.id">
                                                                {{auction.title}}
                                                                <br>
                                                                {{auction.day_date}} <span class="bold">({{auction.product_count}})</span>

                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- item -->
                                     
                                    <!-- item -->
                                    <div class="card">
                                        <div class="card-header" id="headingTwo0200">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link btn-block  collapsed" type="button"
                                                    data-toggle="collapse" data-target="#collapseTwo0200"
                                                    aria-expanded="true" aria-controls="collapseTwo0200">
                                                    <i></i>
                                                    {{ $t('gen.city') }}
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo0200" class="collapse" aria-labelledby="headingTwo0200"
                                            data-parent="#accordionExample">
                                            <div class="card-body">
                                                <button class="btn reset-btn" type="button"  @click="clearCities">
                                                    <feather-icon icon="XIcon" />
                                                    {{ $t('gen.card50') }}
                                                </button>
                                                <div class="scroll">
                                                    <div class="item" v-for="(city, index) in cities" :key="index">
                                                        <div
                                                            class="custom-control custom-control-success custom-checkbox">
                                                            <input type="checkbox" v-model="citiesL" :checked="citiesL.includes(city.id)? true : false" :value="city.id" class="custom-control-input "
                                                                :id="'CheckCity'+city.id">
                                                            <label class="custom-control-label" :for="'CheckCity'+city.id">
                                                                {{city.title}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- item -->
                                    <div class="card">
                                        <div class="card-header" id="headingTwo2">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link btn-block  collapsed" type="button"
                                                    data-toggle="collapse" data-target="#collapseTwo2"
                                                    aria-expanded="true" aria-controls="collapseTwo2">
                                                    <i></i>
                                                    {{ $t('gen.card19') }}
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo2" class="collapse show" aria-labelledby="headingTwo2"
                                            data-parent="#accordionExample">
                                            <div class="card-body">
                                                <button class="btn reset-btn" type="button"  @click="clearBrands">
                                                    <feather-icon icon="XIcon" />
                                                    {{ $t('gen.card50') }}
                                                </button>
                                                <div class="scroll">
                                                    <div class="item" v-for="(brand, index) in brands" :key="index">
                                                        <div
                                                            class="custom-control custom-control-success custom-checkbox">
                                                            <input type="checkbox" v-model="brandsL" :checked="brandsL.includes(brand.value)? true : false" :value="brand.value" class="custom-control-input "
                                                                :id="'CheckBrand'+brand.value">
                                                            <label class="custom-control-label" :for="'CheckBrand'+brand.value">
                                                                {{brand.label}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- item -->
                                    <!-- item -->
                                    <div class="card">
                                        <div class="card-header" id="headingTwo22">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link btn-block  collapsed" type="button"
                                                    data-toggle="collapse" data-target="#collapseTwo22"
                                                    aria-expanded="false" aria-controls="collapseTwo22">
                                                    <i></i>
                                                    {{ $t('gen.card51') }}
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo22" class="collapse" aria-labelledby="headingTwo22"
                                            data-parent="#accordionExample">
                                            <div class="card-body">
                                                <button class="btn reset-btn" type="button"  @click="clearStyles">
                                                    <feather-icon icon="XIcon" />
                                                    {{ $t('gen.card50') }}
                                                </button>
                                                <div class="scroll">
                                                    <div class="item" v-for="(style, index) in styles" :key="index">
                                                        <div
                                                            class="custom-control custom-control-success custom-checkbox">
                                                            <input type="checkbox" v-model="stylesL" :checked="stylesL.includes(style.value)? true : false" :value="style.value" class="custom-control-input "
                                                                :id="'Checkstyle'+style.value">
                                                            <label class="custom-control-label" :for="'Checkstyle'+style.value">
                                                                {{style.label}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- item -->
                                    <!-- item -->
                                    <div class="card">
                                        <div class="card-header" id="headingTwo3">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link btn-block  collapsed" type="button"
                                                    data-toggle="collapse" data-target="#collapseTwo3"
                                                    aria-expanded="false" aria-controls="collapseTwo3">
                                                    <i></i>
                                                    {{ $t('gen.make_year') }}
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo3" class="collapse" aria-labelledby="headingTwo3"
                                            data-parent="#accordionExample">
                                            <div class="card-body">
                                                <button class="btn reset-btn" type="button" @click="clearYears">
                                                    <feather-icon icon="XIcon" />
                                                    {{ $t('gen.card50') }}
                                                </button>
                                                <div class="scroll">
                                                    <div class="item" v-for="(year, index) in years" :key="index">
                                                        <div
                                                            class="custom-control custom-control-success custom-checkbox">
                                                            <input type="checkbox" v-model="yearsL"  :checked="yearsL.includes(year.value)? true : false" :value="year.value" class="custom-control-input "
                                                                :id="'CheckYY'+year.value">
                                                            <label class="custom-control-label" :for="'CheckYY'+year.value">
                                                                {{year.label}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- item -->
                                    <!-- item -->
                                    <div class="card">
                                        <div class="card-header" id="headingTwo4">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link btn-block  collapsed" type="button"
                                                    data-toggle="collapse" data-target="#collapseTwo4"
                                                    aria-expanded="false" aria-controls="collapseTwo4">
                                                    <i></i>
                                                    {{ $t('car.condition') }}
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo4" class="collapse" aria-labelledby="headingTwo4"
                                            data-parent="#accordionExample">
                                            <div class="card-body">
                                                <button class="btn reset-btn" type="button" @click="clearConditions">
                                                    <feather-icon icon="XIcon" />
                                                    {{ $t('gen.card50') }}
                                                </button>
                                                <div class="scroll">
                                                    <div class="item" v-for="(condition, index) in conditions" :key="index">
                                                        <div
                                                            class="custom-control custom-control-success custom-checkbox">
                                                            <input type="checkbox" v-model="conditionsL"  :checked="conditionsL.includes(condition.value)? true : false" :value="condition.value" class="custom-control-input "
                                                                :id="'CheckY'+condition.value">
                                                            <label class="custom-control-label" :for="'CheckY'+condition.value">
                                                                {{condition.label}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- item -->
                                    <div class="card">
                                        <div class="card-header" id="headingThree">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link btn-block collapsed" type="button"
                                                    data-toggle="collapse" data-target="#collapseThree"
                                                    aria-expanded="false" aria-controls="collapseThree">
                                                    <i></i>
                                                    {{ $t('gen.card53') }}
                                                </button>
                                            </h2>
                                        </div>
                                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree"
                                            data-parent="#accordionExample">
                                            <div class="card-body">
                                                <button class="btn reset-btn"  type="button" @click="clearPrices">
                                                    <feather-icon icon="XIcon" />
                                                    {{ $t('gen.card50') }}
                                                </button>
                                                <PriceRangeSlider @changePrice="minPriceF" :triggerrest="triggerRemove" />
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!-- item -->
                                    <div class="card" v-for="(attribute, index) in attributes" :key="index">
                                        <div class="card-header" :id="'headingTwo11'+index">
                                            <h2 class="mb-0">
                                                <button class="btn btn-link btn-block  collapsed" type="button"
                                                    data-toggle="collapse" :data-target="'#collapseTwo11'+index"
                                                    aria-expanded="false" :aria-controls="'collapseTwo11'+index">
                                                    <i></i>
                                                    {{attribute.title}}
                                                </button>
                                            </h2>
                                        </div>
                                        <div :id="'collapseTwo11'+index" class="collapse" :aria-labelledby="'headingTwo11'+index"
                                            data-parent="#accordionExample">
                                            <div class="card-body">
                                                <button class="btn reset-btn"  type="button" @click="clearAttributes">
                                                    <feather-icon icon="XIcon" />
                                                    {{ $t('gen.card50') }}
                                                </button>
                                                <div class="scroll">
                                                    <div class="item" v-for="(it, index2) in attribute.children" :key="index2">
                                                        <div
                                                            class="custom-control custom-control-success custom-checkbox">
                                                            <input type="checkbox" v-model="attributesL"  :checked="attributesL.includes(it.id)? true : false" :value="it.id" class="custom-control-input "
                                                                :id="'Check11'+it.id">
                                                            <label class="custom-control-label" :for="'Check11'+it.id">
                                                                {{it.title}}
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- item -->
                                </div>
                                <div class="btns-wr">
                                     <a @click="attributesArr2" class="btn btn-block btn-success">{{$t('gen.card54')}} </a>
                                    <!--<a href="#" class="btn btn-block btn-trans"> {{$t('gen.save')}}</a> -->
                                </div>
                            </form>
                        </div>
                    </div>

                </div>
                <div class="col-xl-auto cards-col-2">
                    <div class="cont-bar">
                        <div class="dropdown dr-style1 ">
                            <button class="btn  dropdown-toggle" type="button" id="dropdown2" data-toggle="dropdown"
                                aria-expanded="false">
                                {{ $t('gen.show') }}
                            </button>
                            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdown2">
                                <a class="dropdown-item" @click=" $router.replace({ query: { ...$route.query, page_count: '15' } }) ">15</a>
                                <a class="dropdown-item" @click=" $router.replace({ query: { ...$route.query, page_count: '25' } }) ">25</a>
                                <a class="dropdown-item" @click=" $router.replace({ query: { ...$route.query, page_count: '35' } }) ">35</a>
                                <a class="dropdown-item" @click=" $router.replace({ query: { ...$route.query, page_count: '45' } }) ">45</a>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div class="text">{{ $t('gen.show') }} {{$store.state.filter.PagingPerPage}} {{ $t('gen.from') }} {{$store.state.filter.PagingTotal}} {{ $t('gen.item') }}</div>
                            <nav aria-label="...">
                                <ul class="pagination">

                                    <li class="page-item" v-for="item1 in $store.state.filter.Paging" :key="item1.value" :class="(item1.value == $store.state.filter.PagingCurrentPage)? ' active' : ''">
                                        <button class="page-link" type="button" @click=" $router.replace({ query: { ...$route.query, page: item1.text } }) "  v-if="(item1.value != $store.state.filter.PagingCurrentPage)">{{item1.text}}</button>
                                        <span class="page-link" v-if="(item1.value == $store.state.filter.PagingCurrentPage)">
                                            {{item1.text}}
                                            <span class="sr-only">(current)</span>
                                        </span>
                                    </li>
                                    <!-- <li class="page-item active">
                                        <span class="page-link">
                                            2
                                            <span class="sr-only">(current)</span>
                                        </span>
                                    </li>
                                    <li class="page-item"><a class="page-link" href="#">3</a></li>
                                    <li class="page-item">
                                        <a class="page-link" href="#">{{ $t('gen.next') }}</a>
                                    </li>
                                    <li class="page-item"><a class="page-link" href="#">9</a></li> -->
                                </ul>
                            </nav>
                        </div>
                    </div>
                    <div class="row cards-row"  :class="(isList)? ' list' : ''">
                        
							<CarCardOne  v-for="(product, index) in products" :key="index" :product="product"/>
                    </div>
                    <div class="row  cards-row">
                        <div class="d-flex" style="    margin: auto;">
                            <div class="text">{{ $t('gen.show') }} {{$store.state.filter.PagingPerPage}} {{ $t('gen.from') }} {{$store.state.filter.PagingTotal}} {{ $t('gen.item') }}</div>
                            <nav aria-label="...">
                                <ul class="pagination  pagination-btm">

                                    <li class="page-item" v-for="item1 in $store.state.filter.Paging" :key="item1.value" :class="(item1.value == $store.state.filter.PagingCurrentPage)? ' active' : ''">
                                        <button class="page-link" type="button" @click=" $router.replace({ query: { ...$route.query, page: item1.text } }) "  v-if="(item1.value != $store.state.filter.PagingCurrentPage)">{{item1.text}}</button>
                                        <span class="page-link" v-if="(item1.value == $store.state.filter.PagingCurrentPage)">
                                            {{item1.text}}
                                            <span class="sr-only">(current)</span>
                                        </span>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import { mapGetters, mapActions ,mapMutations} from "vuex";
import store from '@/store'
import CarCardOne from './CarCardOne.vue'
import PriceRangeSlider from '../PriceRangeSlider.vue'
import axios from "../../axios";
export default {
	components:{
    CarCardOne,
    PriceRangeSlider
},
    watch: {
		"$store.state.home.should_reload": {
			handler(val) {
				if(val != 0){
					this.$store.dispatch("filter/fetchProducts", this.$route.query).then((res) => {
                    this.products = res.data.data.products.data;
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                });
			}
		},
		deep: true,
	},
    $route: {
      async handler(route) {
		// if (this.allAc) {
        //   await this.$router.replace({ query: { ...route.query, allAc: 1 } });
        //   return;
        // }
        this.products = [];
        this.setFilter({ ...route.query });
        this.$store.dispatch("filter/fetchProducts", route.query).then((res) => {
            this.products = res.data.data.products.data;
            window.scrollTo({
				top: 0,
				left: 0,
				behavior: 'smooth'
			});
        });
		if(route.query.brandsL !== undefined)
        {
            this.brandsL = route.query.brandsL.toString().split(',').map(s => s.trim());
        }else{
            this.brandsL = [];
        }
		if(route.query.citiesL !== undefined)
        {
            this.citiesL = route.query.citiesL.toString().split(',').map(s => s.trim());
        }else{
            this.citiesL = [];
        }
		if(route.query.stylesL !== undefined)
        {
            this.stylesL = route.query.stylesL.toString().split(',').map(s => s.trim());
        }else{
            this.stylesL =  [];
        }
		if(route.query.yearsL !== undefined)
        {
            this.yearsL = route.query.yearsL.toString().split(',').map(s => s.trim());
        }else{
            this.yearsL = [];
        }
		if(route.query.conditionsL !== undefined)
        {
            this.conditionsL = route.query.conditionsL.toString().split(',').map(s => s.trim());
        }else {
            this.conditionsL = [];
        }
		if(route.query.attributesL !== undefined)
        {
            this.attributesL = route.query.attributesL.toString().split(',').map(s => s.trim());
        }else{
            this.attributesL = [];
        }
      },
      deep: true,
      immediate: true
    },
    auctionsL(val, old){
        // console.log('auctionsL:',val);
        this.auctionsArr()
    },
    brandsL(val, old){
        // console.log('brandsL:',val);
        this.brandsArr()
    },
    citiesL(val, old){
        // console.log('citiesL:',val);
        this.citiesArr()
    },
    stylesL(val, old){
        // console.log('stylesL:',val);
        this.stylesArr()
    },
    yearsL(val, old){
        // console.log('yearsL:',val);
        this.yearsArr()
    },
    conditionsL(val, old){
        // console.log('conditionsL:',val);
        this.conditionsArr()
    },
    attributesL(val, old){
        // console.log('attributesL:',val);
        this.attributesArr()
    }
  },
    computed: {
      ...mapGetters("filter", ["getProducts", "getAuctions", "getFilter", "getSearchBrands", "getSearchStyles", "getSearchYears", "getSearchConditions","getSearchAttributes"]),
    //   products() {
    //     return this.getProducts || []
    //   },
      auctions() {
        return this.getAuctions  ||   []
      },
      brands() {
        return this.getSearchBrands  ||   []
      },
      styles() {
        return this.getSearchStyles  ||   []
      },
      years() {
        return this.getSearchYears  ||   []
      },
      conditions() {
        return this.getSearchConditions  ||   []
      },
      attributes() {
        return this.getSearchAttributes  ||   []
      },
    },

    methods: {
    ...mapActions("filter", ["fetchProducts"]),
    ...mapMutations("filter", ["setProducts", 'setAuctions', 'setFilter']),
	toggleList(){
		this.isList = !this.isList;
	},
	MobileFilter(){
		this.filterMob = !this.filterMob;
	},
	toggleAll(){
		this.allAc = !this.allAc;
        // 
        if (this.allAc) {
            this.AuctionStatus.push('all')
        }else{
            const index = this.AuctionStatus.indexOf("all", 0);
            if (index > -1) {
            this.AuctionStatus.splice(index, 1);
            }
        }
        
        this.AuctionStatusTxt = this.AuctionStatus.toString()
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, auctionStatus: this.AuctionStatusTxt}
        })
        
	},
	togglecur(){
		this.curAc = !this.curAc;
        // 
        if (this.curAc) {
            this.AuctionStatus.push('cur')
        }else{
            const index = this.AuctionStatus.indexOf("cur", 0);
            if (index > -1) {
            this.AuctionStatus.splice(index, 1);
            }
        }
        
        this.AuctionStatusTxt = this.AuctionStatus.toString()
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, auctionStatus: this.AuctionStatusTxt}
        })
        
	},
	togglecom(){
		this.comAc = !this.comAc;
        // 
        if (this.comAc) {
            this.AuctionStatus.push('com')
        }else{
            const index = this.AuctionStatus.indexOf("com", 0);
            if (index > -1) {
            this.AuctionStatus.splice(index, 1);
            }
        }
        
        this.AuctionStatusTxt = this.AuctionStatus.toString()
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, auctionStatus: this.AuctionStatusTxt}
        })
        
	},
	togglefin(){
		this.finAc = !this.finAc;
        // 
        if (this.finAc) {
            this.AuctionStatus.push('fin')
        }else{
            const index = this.AuctionStatus.indexOf("fin", 0);
            if (index > -1) {
            this.AuctionStatus.splice(index, 1);
            }
        }
        
        this.AuctionStatusTxt = this.AuctionStatus.toString()
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, auctionStatus: this.AuctionStatusTxt}
        })
        
	},
	auctionsArr(){
        this.auctionsLTxt = this.auctionsL.toString()
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, auctionsL: this.auctionsLTxt}
        })
        
	},
	brandsArr(){
        this.brandsLTxt = this.brandsL.toString()
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, brandsL: this.brandsLTxt}
        })
	},
	citiesArr(){
        this.citiesLTxt = this.citiesL.toString()
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, citiesL: this.citiesLTxt}
        })
	},
	stylesArr(){
        this.stylesLTxt = this.stylesL.toString()
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, stylesL: this.stylesLTxt}
        })
	},
	yearsArr(){
        this.yearsLTxt = this.yearsL.toString()
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, yearsL: this.yearsLTxt}
        })
	},
	conditionsArr(){
        this.conditionsLTxt = this.conditionsL.toString()
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, conditionsL: this.conditionsLTxt}
        })
	},
	attributesArr(){
        this.attributesLTxt = this.attributesL.toString()
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, attributesL: this.attributesLTxt}
        })
	},
	attributesArr2(){
        this.MobileFilter();
        let randN = Math.floor(Math.random() * 1000) + 1;
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, sideFilter: randN}
        })
	},
      minPriceF(val, max){
        this.minPrice = val;
        this.maxPrice = max;
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, min_price: this.minPrice, max_price: this.maxPrice}
        })
      },
      clearAuctions(){
        this.auctionsL = [];
        this.auctionsLTxt = '';
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, auctionsL: this.auctionsLTxt}
        })
      },
      clearBrands(){
        this.brandsL = [];
        this.brandsLTxt = '';
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, brandsL: this.brandsLTxt}
        })
      },
      clearCities(){
        this.citiesL = [];
        this.citiesLTxt = '';
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, citiesL: this.citiesLTxt}
        })
      },
      clearStyles(){
        this.stylesL = [];
        this.stylesLTxt = '';
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, stylesL: this.stylesLTxt}
        })
      },
      clearYears(){
        this.yearsL = [];
        this.yearsLTxt = '';
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, yearsL: this.yearsLTxt}
        })
      },
      clearConditions(){
        this.conditionsL = [];
        this.conditionsLTxt = '';
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, conditionsL: this.conditionsLTxt}
        })
      },
      clearAttributes(){
        this.attributesL = [];
        this.attributesLTxt = '';
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, attributesL: this.attributesLTxt}
        })
      },
      clearPrices(){
        this.triggerRemove = !this.triggerRemove;
        console.log("::", this.triggerRemove)
        this.pricesL = [];
        this.pricesLTxt = '';
        const q = this.$route.query;
        this.$router.replace({ query: 
            {...q, pricesL: this.pricesLTxt}
        })
      },
      
	show_incoming(){
		let r_q = this.$route.query;
		console.log('r_q', r_q);
		if(this.$store.state.filter.show_cars == 'incoming'){
			this.$store.state.filter.show_cars = 'available';
			this.$router.replace({ query: { ...r_q, show_cars: 'available'}  }) 
			
		}else{
			this.$store.state.filter.show_cars = 'incoming';
			this.$router.replace({ query:  {...r_q, show_cars: 'incoming'}  }) 

		}
	},
	 getInComingProductsCount(){
		 axios.get(`/page/home-incoming-count`, {}).then((response) => {
			this.inComingCount =  response.data.data.products_count;
		}).catch((error) => {
			console.log(error)
		});
	},
  },
	data(){
		return {
			inComingCount:0,
            cities:[],
            products:[],
            triggerRemove: 0,
            filterMob: 0,
            minPrice: null,
            maxPrice: null,
            auctionsL:[],
            citiesL:[],
            citiesLTxt:'',
            brandsL:[],
            stylesL:[],
            yearsL:[],
            attributesL:[],
            conditionsL:[],
            auctionsLTxt:'',
            allAc:false,
            curAc:false,
            comAc:false,
            finAc:false,
            AuctionStatus:[],
            AuctionStatusTxt:'',
            brandsLTxt:'',
            stylesLTxt:'',
			isList:false,
			options1: [
				{
				text: "name1",
				value: "value1"
				}, {
				text: "name2",
				value: "value2"
				}, {
				text: "name3",
				value: "value3"
				}],
		}
	},
    mounted(){
        this.products = [];
        this.$store.dispatch("filter/fetchSearchFilters", {});
        this.getInComingProductsCount();
        axios.get(`/cities`, {keywords: this.search}).then((response) => {
                this.cities = response.data.data.rows;
            }).catch((error) => {
                console.log(error)
            });
    }
}
</script>
